import { ChartMessage, ChartState } from './types'
import { getEventFieldsList } from './utils'

export const reducer: WidgetReducerType<ChartState, ChartMessage> = (state = { events: [], fields: [] }, message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            return { events: [], fields: getEventFieldsList(message.events.fields) }
        case 'event':
            return { ...state, events: [...message.events, ...state.events] }

        default:
            return state
    }
}
